import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SearchProviderMixin from "../../../lib/ModelMixins/SearchProviders/SearchProviderMixin";
import CommonStrata from "../../../lib/Models/Definition/CommonStrata";
import CreateModel from "../../../lib/Models/Definition/CreateModel";
import Terria from "../../../lib/Models/Terria";
import BingMapsSearchProviderTraits from "../../../lib/Traits/SearchProviders/BingMapsSearchProviderTraits";
class TestSearchProvider extends SearchProviderMixin(CreateModel(BingMapsSearchProviderTraits)) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", "test");
    _defineProperty(this, "logEvent", jasmine.createSpy());
    _defineProperty(this, "doSearch", jasmine.createSpy().and.callFake(() => Promise.resolve()));
  }
}
describe("SearchProviderMixin", () => {
  let terria;
  let searchProvider;
  beforeEach(() => {
    terria = new Terria({
      baseUrl: "./"
    });
    searchProvider = new TestSearchProvider("test", terria);
    searchProvider.setTrait(CommonStrata.definition, "minCharacters", 3);
    searchProvider.logEvent.calls.reset();
    searchProvider.doSearch.calls.reset();
  });
  it(" - properly mixed", () => {
    expect(SearchProviderMixin.isMixedInto(searchProvider)).toBeTruthy();
  });
  it(" - should not run search if searchText is undefined", () => {
    const result = searchProvider.search(undefined);
    expect(result.resultsCompletePromise).toBeDefined();
    expect(result.message).toBeDefined();
    expect(searchProvider.logEvent).not.toHaveBeenCalled();
    expect(searchProvider.doSearch).not.toHaveBeenCalled();
  });
  it(" - should not run search if only spaces", () => {
    const result = searchProvider.search("        ");
    expect(result.resultsCompletePromise).toBeDefined();
    expect(result.message).toBeDefined();
    expect(searchProvider.logEvent).not.toHaveBeenCalled();
    expect(searchProvider.doSearch).not.toHaveBeenCalled();
  });
  it(" - should not run search if searchText less than minCharacters", () => {
    const result = searchProvider.search("12");
    expect(result.resultsCompletePromise).toBeDefined();
    expect(result.message).toBeDefined();
    expect(searchProvider.logEvent).not.toHaveBeenCalled();
    expect(searchProvider.doSearch).not.toHaveBeenCalled();
  });
  it(" - should run search if searchText is valid", () => {
    const result = searchProvider.search("1234");
    expect(result.resultsCompletePromise).toBeDefined();
    expect(result.message).not.toBeDefined();
    expect(searchProvider.logEvent).toHaveBeenCalled();
    expect(searchProvider.doSearch).toHaveBeenCalled();
  });
});